import validate from "/vercel/path0/node_modules/nuxt/dist/pages/runtime/validate.js";
import _0_45auth_45validate_45token_45global from "/vercel/path0/apps/site/middleware/0.authValidateToken.global.ts";
import _1_45auth_45global from "/vercel/path0/apps/site/middleware/1.auth.global.js";
import _2_45utm_45global from "/vercel/path0/apps/site/middleware/2.utm.global.js";
import auth_45provider_45global from "/vercel/path0/apps/site/middleware/auth-provider.global.ts";
import navigation_45global from "/vercel/path0/apps/site/middleware/navigation.global.js";
export const globalMiddleware = [
  validate,
  _0_45auth_45validate_45token_45global,
  _1_45auth_45global,
  _2_45utm_45global,
  auth_45provider_45global,
  navigation_45global
]
export const namedMiddleware = {
  "house-transaction": () => import("/vercel/path0/apps/site/middleware/house-transaction.js"),
  house: () => import("/vercel/path0/apps/site/middleware/house.js"),
  login: () => import("/vercel/path0/apps/site/middleware/login.ts"),
  "property-sales": () => import("/vercel/path0/apps/site/middleware/property-sales.js"),
  "redirect-wishlist": () => import("/vercel/path0/apps/site/middleware/redirect-wishlist.ts"),
  "search-destination-filter-validation": () => import("/vercel/path0/apps/site/middleware/search-destination-filter-validation.js"),
  "search-destination-validation": () => import("/vercel/path0/apps/site/middleware/search-destination-validation.ts"),
  "stay-proposal-edit": () => import("/vercel/path0/apps/site/middleware/stay-proposal-edit.js"),
  "unapproved-contract-information": () => import("/vercel/path0/apps/site/middleware/unapproved-contract-information.js")
}